export enum OrgFeaturesList {
  keystone = 'keystone',
}

export enum ThirdPartyVendors {
  keystone = 'keystone',
}
